export const rows = [
  {_id: 0, name: 'Adarsh Kumar', email: 'adarshkumar@codewora.com', earning: '$234', country: 'country'},
  {_id: 1, name: 'Monti Kumar', email: 'montikumar@codewora.com', earning: '$234', country: 'country'},
  {_id: 2, name: 'Naveen Saini', email: 'naveensaini@codewora.com', earning: '$234', country: 'country'},
  {_id: 3, name: 'Manoj Kumar', email: 'manojkumar@codewora.com', earning: '$234', country: 'country'},
  {_id: 4, name: 'Arpit Sharma', email: 'arpitsharma@codewora.com', earning: '$234', country: 'country'},
  {_id: 5, name: 'Rakhi Gupta', email: 'rakhigupta@codewora.com', earning: '$234', country: 'country'},
]

export const columnFields = [
  {
    field: 'name',
    headerName: 'Charge Name',
    minWidth: 100,
    sortable: false,
    flex: 1,
  },
  {
    field: 'email',
    headerName: 'Email',
    minWidth: 100,
    sortable: false,
    flex: 1,
  },
  {
    field: 'earning',
    headerName: 'Earning',
    minWidth: 100,
    sortable: false,
    flex: 1,
  },
  {
    field: 'country',
    headerName: 'Country',
    minWidth: 100,
    sortable: false,
    flex: 1,
  },
];